import { Component, OnInit } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MonitoringService } from 'src/app/services/monitoring.service';
import { Utility } from 'src/app/core/common';
import { PersianDate } from 'src/app/core/persian-date';

@Component({
  selector: 'admin-stats-dashboard',
  templateUrl: './stats-dashboard.component.html',
  styleUrls: ['./stats-dashboard.component.scss']
})
export class StatsDashboardComponent implements OnInit {
  stats: any[];
  Utility = Utility;
  statsTime: Date;

  tab = 'stats';
  seekerStats: any[];
  reportFrom = (new PersianDate().addMonth(-1).toGregorian());
  reportTo = new Date()
  actionReport = {
    actions: ["new-seeker", "vanguard-paying", "vanguard-paid"],
    interval: 'Day'
  };
  smsSendReport = {
    interval: 'Day'
  };
  smsSendStats: any[];
  smsActionReport = {
  };
  smsActionStats: any[];

  constructor(private monitoringService: MonitoringService) {
    const interval$ = interval(10 * 60 * 1000);
    interval$
      .pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.loadDashboardStats())
  }

  async ngOnInit() {
    await this.loadDashboardStats();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  hidden = [
    'ActionLog - Operator',
    'ActionLog - User-Authenticate',
    'ActionLog - User-Logout',
    'ActionLog - User-utm-click',
    'ActionLog - Seeker-favorite-',
    'ActionLog - Seeker-delete-apply',
    'ActionLog - Seeker-edit-subscribe',
    'ActionLog - Seeker-verify-subscribe',
    'ActionLog - Employer-set-job-free'
  ];
  hourlyAlarm = [
    'ActionLog - Employer-create-job',
    'ActionLog - Employer-new-employer',
    'ActionLog - Seeker-apply',
    'ActionLog - Seeker-completed-resume',
    'ActionLog - Seeker-edit-resume',
    'ActionLog - Seeker-new-resume',
    'ActionLog - Seeker-new-seeker',
    'ActionLog - Seeker-subscribe',
    'ActionLog - User-Login',
    'IndexedJob-website',
    'JobClick-indexed',
    'JobClick-karpishe',
    'JobClick-paid',
    'Payment-pending',
    'Payment-settled'
  ];
  dailyAlarm = [
    'ActionLog - Employer-add-job-budget-paid',
    'ActionLog - Employer-add-job-budget-paying',
    'ActionLog - Employer-register-nps',
    'ActionLog - Employer-set-job-budget-paid',
    'ActionLog - Employer-set-job-budget-paying',
    'ActionLog - Seeker-vanguard-paid',
    'ActionLog - Seeker-vanguard-paying',
    'IndexedJob-telegram',
    'NotificationLog-email',
    'NotificationLog-sms'
  ];
  diffAlarm = [
    'ActionLog - Seeker-completed-resume',
    'ActionLog - Seeker-edit-resume',
    'ActionLog - Seeker-new-resume',
    'ActionLog - Seeker-new-seeker',
    'ActionLog - Seeker-subscribe',
    'ActionLog - User-Login',
    'IndexedJob-website',
    'IndexedJob-telegram',
    'JobClick-indexed',
    'JobClick-karpishe',
    'JobClick-paid',
    'Payment-pending',
    'Payment-settled'
  ];


  async loadDashboardStats() {
    this.stats = [];
    this.stats = await this.monitoringService.dashboardStats();
    this.stats = this.stats.filter(_ => !this.hidden.find(h => `${_.type}-${_.action}`.startsWith(h)));
    this.stats.forEach(_ => {
      _.data.average = Utility.nonZeroAverage([_.data.LastWeek, _.data.Last2Week, _.data.Last3Week]);
      if (_.data.average)
        _.data.diff = ((_.data.OneDay - _.data.average) * 100) / _.data.average;
      let title = `${_.type}-${_.action}`;
      _.data.OneHour_Alarm = (_.data.OneHour==0 && this.hourlyAlarm.includes(title));
      _.data.OneDay_Alarm = (_.data.OneDay==0 && this.dailyAlarm.includes(title));
      _.data.diff_Alarm = (_.data.diff<=-20 && this.diffAlarm.includes(title));
        
    });

    this.statsTime = new Date();
  }

  async loadSeekerStats() {
    this.seekerStats = [];
    this.seekerStats = await this.monitoringService.actionReport(this.reportFrom, this.reportTo, this.actionReport.actions, this.actionReport.interval);
  }
  async loadSmsSendStats() {
    this.smsSendStats = [];
    this.smsSendStats = await this.monitoringService.smsSendReport(this.reportFrom, this.reportTo, this.smsSendReport.interval);
  }
  async loadSmsActionStats() {
    this.smsActionStats = [];
    this.smsActionStats = await this.monitoringService.smsActionReport(this.reportFrom, this.reportTo);
  }

}
